import { lazy } from 'react'

export const KitCancelOfferV1 = lazy(() => import('./kitV1/KitCancelOfferV1'))
